import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';
import router from './router';
import store from './store';
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import aws_exports from './aws-exports';
/*import BootstrapVue from 'bootstrap-vue';*/
import VueSweetalert2 from 'vue-sweetalert2';
import Vuelidate from 'vuelidate';
import axios from 'axios';
import vmodal from 'vue-js-modal';
import vuetify from './plugins/vuetify';
import VueMoment from 'vue-moment';
import VueLoading from 'vuejs-loading-plugin';
//import moment from 'moment-timezone';
//import 'tailwindcss/dist/tailwind.css';
/*import 'tailwindcss/dist/base.css';
import 'tailwindcss/dist/components.css';
import 'tailwindcss/dist/utilities.css';
import './assets/styles/index.css';*/
import './assets/styles/index.css';
import './assets/styles/style.css';
import './assets/style/custom.css';
import './assets/styles/responsive.css';
import './assets/style/responsive.css';
import userMix from './mixins/user-mix';

Vue.mixin(userMix);

/*import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing);*/

//sweet alert code

/*import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents);*/

import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

import swal from 'sweetalert2';
 window.swal = swal;

 const Toast = swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', swal.stopTimer)
    toast.addEventListener('mouseleave', swal.resumeTimer)
  }
});

window.Toast = Toast;

window.Fire = new Vue();


Vue.use(vmodal);

Vue.use(VueMoment);

Vue.use(VueLoading, {
  dark: true, // default false
  //text: 'Ladataan', // default 'Loading'
  //loading: true, // default false
 // customLoader: myVueComponent, // replaces the spinner and text with your own
  //background: 'rgb(255,255,255)', // set custom background
 // classes: ['myclass'] // array, object or string
});
//import store from './store';
// fire emit
window.Fire = new Vue();
Vue.use(VueSweetalert2);
/*Vue.use(BootstrapVue);*/
Vue.use(Vuelidate);
Amplify.configure(aws_exports)
Vue.use(AmplifyPlugin, AmplifyModules);

Vue.config.productionTip = false
new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
